import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavbarComponent.css'; // Make sure to import your CSS file
import '../App.css'

const NavbarComponent = () => {
    return (
        <Navbar expand="md" variant="dark" className="custom-navbar">
            <Container>
                <LinkContainer to="/">
                    <Navbar.Brand>Anam Sarwar</Navbar.Brand>
                </LinkContainer>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ms-auto custom-nav">
                        <LinkContainer to="/home">
                            <Nav.Link className="nav-link-spacing">Home</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/about">
                            <Nav.Link className="nav-link-spacing">About</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/portfolio">
                            <Nav.Link className="nav-link-spacing">Portfolio</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/quote">
                            <Nav.Link className="nav-link-spacing">Get Free Quote</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/login">
                            <Button variant="outline-info" className="custom-button nav-link-spacing">Login</Button>
                        </LinkContainer>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavbarComponent;
